import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useReactToPrint } from "react-to-print";
import { ApiHook } from "../../hooks/apiHook";
import { useSelector } from "react-redux";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { formatDate } from "../../utils/formateDate";


const PurchaseInvoice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const params = useParams();
  const tableRef = useRef();
  const invoiceNo = params.id;

  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const userSelectedCurrency = useSelector(
    (state) => state?.user?.selectedCurrency
  );

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  const handleBack = () => {
    navigate('/repurchase-report')
  }

  //---------------------------------- API ------------------------------------
  const invoice = ApiHook.CallRepurchaseInvoice(invoiceNo);

  return (
    <>
      <div className="page_head_top">{t("purchase_invoice")}</div>
      <div className="row">
         <div className="col-md-8 m-auto">
          <div className="purchase_invoice">
          <div className="invoice-modal" ref={tableRef} style={{padding:"10px"}}>
          <div className="col-md-6 d-flex align-items-center" >
          <img src="/images/logo_user.png" alt="" style={{ width: "30%" }} />
         </div>
        <div className="row  border-bottom border-top border-1 mt-3 custom-light-grey">
          <div className="main-details">
            <b style={{font:"caption",fontWeight:"bold"}}>{t("purchaseDate")} :{" "}</b>
            {formatDate(invoice?.data?.date)}
          </div>
          <div className="main-details">
            <b style={{font:"caption",fontWeight:"bold"}}>{t("paymentMethod")}</b> : {invoice?.data?.paymentDetails?.paymentMethod}
          </div>
          <div className="main-details">
            <b style={{font:"caption",fontWeight:"bold"}}>{t("ShippingMethod")}</b> : {invoice?.data?.shippingDetails?.shipping_method}
          </div>
        </div>

        {/* <div className="row pb-1 p-2 border-bottom border-1  custom-light-grey">
          <div className="col-md-12">
            <p className="font-weight-bold mb-2">{t("seller-deatils")}</p>

            <p className="mb-1 ">4MyBeautyness Oy</p>
            <p className="mb-1 ">{t("BusinessID")} : 3435976-7</p>
            <p className="mb-1 ">{t("VATreg")} : FI34359767</p>
            <p className="mb-1 ">{t("Address")} : Äänekoski</p>
            <p className="mb-1 ">{t("Phone")} : +358407326725</p>
            <p className="mb-1 ">
              {t("email")} : asiakaspalvelu@4mybeautyness.fi
            </p>
          </div>
        </div> */}

        <div className="row pb-1 p-2 border-bottom border-1  custom-light-grey">
          <div className="col-md-6">
            <p className="font-weight-bold mb-2">{t("client_information")}</p>
            <p className="mb-1">
              {invoice?.data?.clientInfo?.name}{" "}
              {invoice?.data?.clientInfo?.lastname}
            </p>
            <p className="mb-1">{invoice?.data?.clientInfo?.address}</p>
            <p className="mb-1">{invoice?.data?.clientInfo?.city}</p>
            <p className="mb-1">{invoice?.data?.clientInfo?.email}</p>
            <p className="mb-1">{invoice?.data?.clientInfo?.mobile}</p>
          </div>

          <div className="col-md-6 text-end">
            <p className="font-weight-bold mb-2">{t("shipping_details")}</p>
            <p className="mb-1">
              {invoice?.data?.shippingDetails?.name}{" "}
              {invoice?.data?.shippingDetails?.lastname}
            </p>
            <p className="mb-1">
              {invoice?.data?.shippingDetails?.shipping_method}
            </p>
            <p className="mb-1">
              {invoice?.data?.shippingDetails?.payment_city}
            </p>
            <p className="mb-1">
              {invoice?.data?.shippingDetails?.shipping_country}
            </p>
            <p className="mb-1">
              {invoice?.data?.shippingDetails?.shipping_postcode}
            </p>
          </div>
        </div>

        <div className="row p-1">
          <div className="col-md-12">
            <table className="table invoice">
              <thead>
                <tr>
                  <th className="text-center  font-weight-bold">
                  {t("#")}
                  </th>
                  <th className="text-center  font-weight-bold">
                    {t("package")}
                  </th>
                  <th className="text-center  font-weight-bold">
                    {t("quantity")}
                  </th>
                  <th className="text-center  font-weight-bold">
                    {t("unitKc")}
                  </th>
                  <th className="text-center   font-weight-bold">
                    {t("totalKC")}
                  </th>
                  <th className="text-center  font-weight-bold">
                    {t("reatilUnitprice",{
                      value:  invoice?.data?.invoiceData?.configureVat
                    })}
                  </th>
                  <th className="text-center  font-weight-bold">
                    {t("discountUnitprice",{
                      value:  invoice?.data?.invoiceData?.configureVat
                    })}
                  </th>
                  
                  <th className="text-center  font-weight-bold text-end">
                    {t("total")}
                  </th>

                </tr>
              </thead>
              <tbody >
                {invoice?.data?.items?.map((item, index) => (
                  <tr
                    key={index}
                    style={{ textAlign: "center", fontSize: "16px" }}
                  >
                    <td>{index + 1}</td>
                    <td>{item.package}</td>
                     <td>{item.quantity}</td>
                      <td>{item.pairValue}</td>
                       <td>{item.totalPairValue}</td>
                    <td className="text-center">
                      {` ${CurrencyConverter(
                        item.price,
                        conversionFactor
                      )} ${userSelectedCurrency.symbolLeft}`}
                    </td>   
                    <td className="text-center">
                      {` ${CurrencyConverter(
                        item.discountPrice,
                        conversionFactor
                      )} ${userSelectedCurrency.symbolLeft}`}
                    </td>
                     
                    <td className="text-center">
                      {` ${CurrencyConverter(
                        item.discountTotal,
                        conversionFactor
                      )} ${userSelectedCurrency.symbolLeft}`}
                    </td>

                  </tr>
                ))}
                <tr></tr>
                {invoice?.data?.priceFinalDetails?.map((items) => (
                  <tr>
                    <td className="text-end" colSpan={8}>
                      {t(items.code,{
                        value:invoice?.data?.invoiceData?.configureVat
                      })}:{" "}
                      {` ${CurrencyConverter(
                        items.value,
                        conversionFactor
                      )} ${userSelectedCurrency.symbolLeft}`}{" "}
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>


        </div>
        <button style={{float:"right"}}
            type="button"
            className="btn btn-labeled btn-primary print-button"
            onClick={handlePrint}
          >
            <span className="btn-label">
              <i className="fa fa-print"></i>
            </span>{" "}
            {t("print")}
          </button>
        </div>

          


       
          {/* <div className="purchase_invoice" ref={tableRef}>
              <button className="print-button" style={{backgroundColor:'white'}} onClick={handleBack}>
                <i className="fa fa-angle-left" style={{fontSize: "1.3em"}}></i>
              </button>
            <div className="row p-2">
              <div className="col-md-6 d-flex align-items-center">
                <img src="/images/logo_user.png" alt="" />
              </div>
              <div className="col-md-6 text-end">
                <p className="font-weight-bold mb-1">
                  {`${t("invoice")}: #${invoiceNo}`}
                </p>
                <p className="text-muted">
                  Date: {formatDate(invoice.data?.date)}
                </p>
                <button
                  type="button"
                  className="btn btn-labeled btn-primary print-button"
                  onClick={handlePrint}
                >
                  <span className="btn-label">
                    <i className="fa fa-print"></i>
                  </span>{" "}
                  {t("print")}
                </button>
              </div>
            </div>

            <hr className="my-1" />

            <div className="row pb-1 p-1">
              <div className="col-md-6">
                <p className="font-weight-bold mb-4">
                  {t("client_information")}
                </p>
                <p className="mb-1">{invoice.data?.clientInfo?.name}</p>
                <p className="mb-1">{invoice.data?.clientInfo?.address}</p>
                <p className="mb-1">{invoice.data?.clientInfo?.city}</p>
                <p className="mb-1">{invoice.data?.clientInfo?.zip}</p>
              </div>

              <div className="col-md-6 text-end">
                <p className="font-weight-bold mb-4">{t("payment_details")}</p>
                <p className="mb-1">
                  <span className="text-muted">{t("paymentMethod")}: </span>
                  {invoice.data?.paymentDetails?.paymentMethod}
                </p>
              </div>
            </div>

            <div className="row p-1">
              <div className="col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="text-uppercase small font-weight-bold">
                        #
                      </th>
                      <th className="text-uppercase small font-weight-bold">
                        {t("package")}
                      </th>
                      <th className="text-uppercase small font-weight-bold">
                        {t("quantity")}
                      </th>
                      <th className="text-uppercase small font-weight-bold text-end">
                        {t("total")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.data?.items?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.package}</td>
                        <td>{item.quantity}</td>
                        <td className="text-end">
                          {`${
                            userSelectedCurrency.symbolLeft
                          } ${CurrencyConverter(
                            item.amount,
                            conversionFactor
                          )}`}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="d-flex flex-row-reverse text-white invoice-total p-4">
              <div className="py-1 px-1 text-end">
                <div className="mb-2">{t("grand_total")}</div>
                <div className="h2 font-weight-light">
                  {`${userSelectedCurrency.symbolLeft} ${CurrencyConverter(
                    invoice.data?.grandTotal,
                    conversionFactor
                  )}`}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PurchaseInvoice;
